import HomeAndCompaniesTable from './homeAndCompaniesTable';

export default HomeAndCompaniesTable;
